import { GENERIC } from './types';

export const loadingAction = () => ({
  type: GENERIC.LOADING,
});

export const stopLoadingAction = () => ({
  type: GENERIC.STOP_LOADING,
});
export const initLoadingAction = () => ({
  type: GENERIC.INIT_LOADING,
});

export const stopInitLoadingAction = () => ({
  type: GENERIC.STOP_INIT_LOADING,
});

export const showSuccessToastAction = message => ({
  type: GENERIC.SUCCESS_TOAST,
  message
});

export const internalServerError = serverErrorMessage => ({
  type: GENERIC.INTERNAL_SERVER_ERROR,
  serverErrorMessage
});

export const showErrorToastAction = message => ({
  type: GENERIC.ERROR_TOAST,
  message
});

export const resetAllMessages = () => ({
  type: GENERIC.RESET_ALL_MESSAGES
});

export const redirectToAction = redirectTo => ({
  type: GENERIC.REDIRECT_ROUTE,
  redirectTo,
});

export const resetRedirectTo = () => ({
  type: GENERIC.RESET_REDIRECT_ROUTE,
});

export const setHamburgerVisibility = visible => ({
  type: GENERIC.SET_HAMBURGER_VISIBILITY,
  visible
});

export const manageSidemenu = (isSideMenuHidden) => ({
  type: GENERIC.MANAGE_SIDEMENU_VISIBILITY,
  isSideMenuHidden
});

export const showAlertNotification = (isAlertNotificationVisible, event) => ({
  type: GENERIC.ALERT_NOTIFICATION,
  isAlertNotificationVisible,
  notification: event
});

